module.exports = __webpack_public_path__ + "static/media/datalife-idble-logo.b6dfdb37.svg";